<template>
  <div>
    <div class="dataset">
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('sleep_main')"
          pill
          variant="outline-secondary"
          >SleepMain</b-button
        >
      </div>
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('sleep_detection')"
          pill
          variant="outline-secondary"
          >SleepDetection</b-button
        >
      </div>
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('sleep_occl')"
          pill
          variant="outline-secondary"
          >SleepFacial</b-button
        >
      </div>
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('live_main')"
          pill
          variant="outline-secondary"
          >Live</b-button
        >
      </div>
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('emotion')"
          pill
          variant="outline-secondary"
          >Emotion</b-button
        >
      </div>
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('audio_v2')"
          pill
          variant="outline-secondary"
          >AudioV2</b-button
        >
      </div>
      <div class="dataset__tab">
        <b-button
          @click.prevent="loadBatches('caregiver')"
          pill
          variant="outline-secondary"
          >Caregiver</b-button
        >
      </div>
    </div>

    <div class="dataset__content">
      <h3 class="check_main__title">{{ batch_type }}</h3>
      <div class="dataset__batch" v-for="(item, index) in batches" :key="index">
        <div class="dataset__batch__mark">
          <div class="dataset__batch__mark--chart">
            {{ batch_type | mark_filter }}
          </div>
        </div>
        <div class="dataset__batch__title">
          <div class="dataset__batch__title--main">
            Batch {{ item.batch_date }}
          </div>
          <div class="dataset__batch__title--last">
            total: {{ item.total_count }} &nbsp labelled:
            {{ item.label_count }} &nbsp skipped: {{ item.skipped_count }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from "@/api/client";

export default {
  data() {
    return {
      batches: [],
      batch_type: "sleep_main"
    };
  },
  methods: {
    loadBatches(batch_type) {
      const vm = this;
      vm.batch_type = batch_type;
      const loader = vm.$loading.show();
      client
        .get("/summary", { type: vm.batch_type })
        .then(res => {
          loader.hide();
          res.results = res.results.sort((a, b) =>
            a.batch_date < b.batch_date ? 1 : -1
          );
          console.log(res.results);
          vm.batches = res.results;
        })
        .catch(err => {
          loader.hide();
          if (err == 401) {
            vm.$router.push("/login");
          }
        });
    },
    toLabelCheck(item) {
      const { batch_date } = item;
      if (this.batch_type === "sleep_main") {
        this.$router.push({
          name: "review_sleep_main",
          params: {
            batch_date
          }
        });
      } else if (this.batch_type === "sleep_detection") {
        this.$router.push({
          name: "review_sleep_detection",
          params: {
            batch_date
          }
        });
      } else if (this.batch_type === "sleep_occl") {
        this.$router.push({
          name: "review_sleep_occl",
          params: {
            batch_date
          }
        });
      }
    }
  },
  filters: {
    mark_filter(data) {
      return data.substr(0, 1);
      // 只取第一個字
    }
  },
  mounted() {
    this.loadBatches("sleep_main");
  }
};
</script>
